export default __webpack_public_path__ + "images/8a5c336b9cecdcfe4d567b1a8bf3db19-petsandanimals.jpg";